import { render, staticRenderFns } from "./TheVideoPlayer.vue?vue&type=template&id=502719bb&scoped=true&lang=html"
import script from "./TheVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./TheVideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./TheVideoPlayer.vue?vue&type=style&index=0&id=502719bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502719bb",
  null
  
)

export default component.exports